import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PrimaryButton } from '../Button/Button';
import { HiLightBulb } from 'react-icons/hi';
import { IoMdClose } from 'react-icons/io';

import css from './FreelancerOnboardingBanner.css';

const FreelancerOnboardingBanner = ({ onOpenModal, onClose }) => {
  return (
    <div className={css.banner}>
      <button className={css.closeButton} onClick={onClose} aria-label="Close">
        <IoMdClose className={css.closeIcon} />
      </button>
      <div className={css.bannerContent}>
        <HiLightBulb className={css.icon} />
        <p className={css.message}>
          <FormattedMessage id="FreelancerOnboardingBanner.message" />
        </p>
        <PrimaryButton className={css.button} onClick={onOpenModal}>
          <FormattedMessage id="FreelancerOnboardingBanner.buttonText" />
        </PrimaryButton>
      </div>
    </div>
  );
};

export default FreelancerOnboardingBanner;
